// extracted by mini-css-extract-plugin
export default {"PaneHeaderIconButton":"PaneHeaderIconButton---xx13u","PaneHeaderIconButton__inner":"PaneHeaderIconButton__inner---xfSRT boxOffsetSmall---Mifr7"};